import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const ArticleContainer = styled.div`
  width: 100%;
  background-color: ${customPalette.accent.white};
  padding: 0;
  border-radius: 16px;
  margin-top: 0;
  box-shadow: none;

  & .article-image {
    margin-bottom: 16px;
    border-radius: 16px 0 0 0;
    float: left;
    margin-right: 16px;
  }

  & .article-content {
    font-size: 14px;
    line-height: 1.5;
    padding: 24px;
    text-align: left; /* Default text alignment */

    &.without-description {
      clear: both;
      padding: 0 24px 24px 24px; /* Add padding to align properly */
    }

    & .article-description {
      font-weight: bold;
      margin-top: 0;
      padding-bottom: 24px;
    }

    .article-inner-content {
      table {
        border-collapse: collapse;
        width: 80%;
        border-bottom: 1px solid #d3d3d3;
        margin-bottom: 2px;
      }

      th,
      td {
        padding: 8px;
        text-align: left;
      }

      th {
        background-color: #f1f1f1;
        font-weight: bold;
      }

      tr:nth-child(even) {
        background-color: #f4f4f4;
      }
    }
  }

  @media (max-width: 1100px) {
    & .article-image {
      float: none;
      margin: 0 auto 16px;
      display: block;
      width: 100%;
      height: auto;
      border-radius: 16px 16px 0 0;
    }
  }

  @media (max-width: 900px) {
    padding: 0;

    & .article-image {
      float: none;
      margin: 0 auto 16px;
      display: block;
      width: 100%;
      height: auto;
      border-radius: 16px 16px 0 0;
    }

    & .article-content .article-description {
      float: none;
      margin-right: 0;
      color: ${customPalette.grey.main};
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%;
      letter-spacing: 0.15px;
    }
  }
`;

export const DateTypography = styled(Typography)({
  fontSize: '12px',
  lineHeight: '130%',
  fontWeight: '500',
  color: customPalette.blue.main,
  padding: '24px 24px 10px 24px',
});

export const TitleTypography = styled(Typography)`
  margin: 0;
  color: ${customPalette.grey[400]};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  padding: 0 24px 10px 24px;
`;
